import styled from "styled-components";

export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;
    
    display: flex;
    align-items: center;
    justify-content: center;


    pointer-events: none; // This allows clicks to pass through to elements below
  
    & > * {
        pointer-events: auto; // But content inside the container will still receive clicks
    }
`;

export const Content = styled.div`
    position: absolute;

    background-color: ${(props) => props.theme.colors.white};
    width: 350px;
    padding: 20px;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    gap: 20px;
    
    @media (max-width: 900px) {
        position: static;
        max-height: 55%;
        max-width: 60%;
    }
`;

export const BarProgress = styled.div`
    height: 5px;
    width: 100%;
    background-color: ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    max-width: 100%;

    &.barfill{
        height: 100%;
        background-color: ${(props) => props.theme.colors.success};
        border-radius: 4px;
        transition: width 0.3s ease; // Adiciona uma transição suave
    }
`;

export const Button = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: ${(props) => props.theme.colors.gray.gray_500};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    border-radius: 4px;
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
`;

export const ContentHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const ContentLine = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
`;

export const ContentProgress = styled.div``;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 30px;
    background-color: #DCFCE7;
    color: ${(props) => props.theme.colors.success};
`;

export const List = styled.div`
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
`;

export const ListItem = styled.p`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: ${(props) => props.theme.colors.success};
`;

export const Text = styled.p`

    font-size: 12px;
    
    &.title{
        font-size: 18px;
    }
    
    &.subtitle{
        font-size: 14px;
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;